import styled from 'styled-components';
import { colors } from '../../../common/styles';

/* Call Started*/
const CustomerBox = styled.div`
  background: ${colors.colorPrimaryDark};
  color: ${colors.colorWhite};
  padding: 3rem;
  text-align: center;

  .name {
    font-size: 25px;
    font-weight: 400;
    letter-spacing: 1px;
  }

  .company {
    font-weight: 300;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .number {
    font-size: 18px;
    font-weight: 400;
  }

  .time {
    opacity: 0.8;
  }
`;

const CallHandlingBox = styled.div`
  background: ${colors.colorWhite};
  color: ${colors.colorCoreBlack};
  padding: 2rem 1rem 2rem 1rem;
  display: flex;
  align-items: center;

  .circle {
    background: #f5f4f7;
    height: 45px;
    width: 45px;
    border-radius: 50px;
    margin: auto;
  }

  .circle i,
  .circle img {
    padding: 11px;
  }
`;
const CallBtn = styled.div`
    padding: 2rem 1rem 2rem 1rem;
    text-align: center;
    background: ${colors.colorWhite};

    button {
        background: #e51e5b;
        color: ${colors.colorWhite};
        padding: 8px 50px;
        border-radius: 20px;
        border: none;
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 1px;
        outline: none;
        cursor: pointer;
`;

/* Call Ended*/

export { CustomerBox, CallHandlingBox, CallBtn };



// WEBPACK FOOTER //
// src/dialpad/components/layout/components/call/style.js